import { Grid } from "antd";
import { useTranslation } from "react-i18next";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { withConditionalComponent } from "src/HOC";
import { PassengerType, SSR_OPTIONS, SSROptionsKeys } from "src/Modules/Flights/constants/JourneyDetails";
import { getNumberLocale } from "src/utility";
import { useJourneyDynamicDetails } from "../../../../../../context";
import { getRowTotal, getSSRColumns, getSSRItems, SSRRow } from "./utils";
import SSRSelectionTableWeb from "./layouts/SSRSelectionTable.web";
import SSRSelectionTableMob from "./layouts/SSRSelectionTable.mob";

const SSRSelectionTableComponent = withConditionalComponent(SSRSelectionTableWeb, SSRSelectionTableMob);

export default function SSRSelectionTable({
  type,
}: {
  type?: SSROptionsKeys;
}) {
  const { t } = useTranslation();
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const { passengersState } = useJourneyDynamicDetails();
  const [passengersInput] = passengersState;
  const passengers: PassengerType[] = passengersInput?.passengers ?? [];

  const ssrOption = SSR_OPTIONS.find((option) => option.value === type);
  if (!type || !ssrOption) return null;

  const columns = getSSRColumns(passengers[0], ssrOption.ssrSelectionType);
  const selectedItems = passengers.flatMap((passenger) => columns.flatMap((column) => getSSRItems(passenger, column, type)));
  const currency = selectedItems[0]?.currency ?? "";
  const formatPrice = (value: number) =>
    `${currency} ${value.toLocaleString(getNumberLocale(), { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`.trim();

  const typeCounters: Partial<Record<PassengerType["type"], number>> = {};
  const rows: SSRRow[] = passengers.map((passenger, index) => {
    const typeIndex = (typeCounters[passenger.type] ?? 0) + 1;
    typeCounters[passenger.type] = typeIndex;
    return { key: index, passenger, typeIndex };
  });

  const grandTotal = rows.reduce((acc, row) => acc + getRowTotal(row.passenger, columns, type), 0);
  const totalLabel = t("Flights.details.ssr.typeTotal", { type: ssrOption.label, defaultValue: "{{type}} total" });

  return (
    <SSRSelectionTableComponent
      trigger={isLargeScreen}
      props={{ rows, columns, type, formatPrice, totalLabel, grandTotal }}
    />
  );
}
